// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2gXzL","validationTips":"StatementDescriptor_validationTips__7l9K7"};